import React, { lazy, Suspense } from "react";
import { Navigate } from "react-router-dom";
import RouteLoader from "../components/ui/RouteLoader";

const Dashboard = lazy(() => import("../pages/dashboard"));
const Login = lazy(() => import("../pages/login"));
const Live = lazy(() => import("../pages/live"));
const Chart = lazy(() => import("../pages/chart"));
const Orders = lazy(() => import("../pages/orders"));
const Strategy = lazy(() => import("../pages/strategy"));
const Stocks = lazy(() => import("../pages/stocks"));
const Users = lazy(() => import("../pages/users"));
const Actions = lazy(() => import("../pages/actions"));
const Console = lazy(() => import("../pages/console"));
const Balance = lazy(() => import("../pages/balance"));
const History = lazy(() => import("../pages/history"));
const More = lazy(() => import("../pages/more"));
const Prediction = lazy(() => import("../pages/prediction"));

const withSuspense = (element) => (
  <Suspense fallback={<RouteLoader />}>{element}</Suspense>
);

const privateRoutes = [
  { path: "/live", element: <Live /> },
  { path: "/chart", element: <Chart /> },
  { path: "/prediction", element: <Prediction /> },
  { path: "/orders", element: <Orders /> },
  { path: "/strategy", element: <Strategy /> },
  { path: "/stocks", element: <Stocks /> },
  { path: "/users", element: <Users /> },
  { path: "/actions", element: <Actions /> },
  { path: "/console", element: <Console /> },
  { path: "/balance", element: <Balance /> },
  { path: "/history", element: <History /> },
  { path: "/more", element: <More /> },
];

export const RouterConfig = (isAuthenticated) => [
  {
    path: "/",
    element: withSuspense(isAuthenticated ? <Dashboard /> : <Login />),
    children: isAuthenticated
      ? [
          ...privateRoutes.map(({ path, element }) => ({
            path,
            element: withSuspense(element),
          })),
          {
            path: "*",
            element: <Navigate to="/" />,
          },
        ]
      : [],
  },
  {
    path: "*",
    element: <Navigate to="/" />,
  },
];

const routesConfig = { RouterConfig };

export default routesConfig;
